import React, {useEffect, useRef, useState} from 'react';
// import 'react-phone-number-input/style.css'
// import PhoneInput from 'react-phone-number-input'

import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';



export default function PhoneCodeSelect({
  value,
  onChange,
  name,
  type,
  label = null,
  placeholder = null,
  validation = null,
  error = null
}) {

    const [mounted,setMounted] = useState(false);
    const shouldMoveCaretToEndRef = useRef(false);
    const defaultCountryCode = typeof(Shopify) != 'undefined' && typeof(Shopify.country) != 'undefined' ? Shopify.country.toLowerCase() : null;
    const preferredCountries = defaultCountryCode !== null ? [defaultCountryCode] : [];
    let style = "";

    const hasError = error && error.error === true;

    if (hasError) {
      style = "gc__input_field_error";
    }

    const labelMarkup = ( label ) ?
      <>
        <label className={"gc__input_label"}>{label}</label>
      </> :
      <></>

    const errorMarkup = hasError && <p className={"gc__input_field_error_message"}>{ error.message }</p>


    const moveCaretToEndIfFocused = () => {
      const input = document.getElementById('gcpMobileSelectInput');

      if (!input || document.activeElement !== input) {
        return;
      }

      const end = input.value.length;
      input.setSelectionRange(end, end);

    }

    useEffect(() => {
      setMounted(true);
    }, []);

    useEffect(() => {
      if (!shouldMoveCaretToEndRef.current) {
        return;
      }

      shouldMoveCaretToEndRef.current = false;

      // Defer one more tick so this runs after IntlTelInput finishes its own caret management.
      setTimeout(() => {
        moveCaretToEndIfFocused();
      }, 0);
    }, [value]);


    return (

      <>
        <div className={"gc__input_container"} >
          { labelMarkup }
          <IntlTelInput
            containerClassName="intl-tel-input"
            inputClassName={`gc__input_field ${style}`}
            placeholder={placeholder}
            fieldName={name}
            fieldId="gcpMobileSelectInput"
            value={value || ""}
            nationalMode={false}
            // onSelectFlag={(dialCode) => {
            //   let noPlusSign = dialCode.replace(/\D/g,'');
            //   if (window.gcpPhoneInputLocked && window.gcpPhoneInputLocked === true) {
            //     return;
            //   }
            //   onChange(`+${noPlusSign}`);
            // }}
            // format={true}
            // formatOnInit={true}
            preferredCountries={preferredCountries}
            defaultCountry={defaultCountryCode}
            onPhoneNumberChange={(isValid, newNumber, selectedCountryData, fullNumber) => {

              if (!mounted || window.gcpPhoneInputLocked === true) {
                return false;
              }

              // console.log({
              //   valid: isValid,
              //   newNumber: newNumber,
              //   selectedCountry: selectedCountryData,
              //   fullNumber: fullNumber
              // });
              const rawInputValue = newNumber || "";
              const noPlusSign = rawInputValue.replace(/\D/g,'');
              const newVal = noPlusSign.length ? `+${noPlusSign}` : "";
              const autoPrependedPlus = noPlusSign.length > 0 && !rawInputValue.trim().startsWith('+');
              const input = document.getElementById('gcpMobileSelectInput');

              if (autoPrependedPlus) {
                shouldMoveCaretToEndRef.current = true;
              }

              onChange(newVal, false); // Update the bulk table on change
            }}
            // onPhoneNumberBlur={(isValid, newNumber, selectedCountryData, fullNumber) => {
            //   if (!mounted) {
            //     return false;
            //   }
            //   let noPlusSign = fullNumber.replace(/\D/g,'');
            //   const newVal = `+${noPlusSign}`;
            //   onChange(newVal, true); // Update the bulk table on blur
            // }}
          />
            {/*<PhoneInput
            international
            className={`gc__input_field ${style}`}
            placeholder={placeholder}
            name={name}
            defaultCountry={defaultCountryCode}
            value={value}
            onChange={onChange}
          />*/}
        </div>
        { errorMarkup }
      </>
    )
}
